import { jsx as _jsx } from "react/jsx-runtime";
import { useFeatureFlag } from '@/lib/feature-flags/useFeatureFlag';
import { cn } from '@/lib/utils';
import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useChatContext } from './ChatProvider';
export function ChatToggleButton() {
    const { t } = useTranslation();
    const { chatOpen, toggleChat } = useChatContext();
    // AI is opt-in per clinic: the region switch AND at least one of the
    // user's clinics opted in (ai_assist), matching the /ai/chat gate.
    const aiRegionEnabled = useFeatureFlag('ai_agent');
    const aiClinicOptedIn = useFeatureFlag('ai_assist');
    const aiAgentEnabled = aiRegionEnabled && aiClinicOptedIn;
    // Region-wide master switch is off — the backend rejects /ai/chat with 503,
    // so don't offer an entry point that can only error.
    if (!aiAgentEnabled)
        return null;
    return (_jsx("button", { onClick: toggleChat, className: cn(
        // 40px on touch-first screens, matching the other TopNav header targets.
        'flex h-8 w-8 shrink-0 items-center justify-center rounded-md transition-colors pointer-coarse:size-10', chatOpen
            ? 'bg-accent-ai/15 text-accent-ai'
            : 'text-foreground/80 hover:bg-muted hover:text-foreground'), title: t('chat.aiResident'), "aria-label": t('chat.aiResident'), "aria-pressed": chatOpen, children: _jsx(Sparkles, { className: "h-4 w-4" }) }));
}
